import BlockChoice from 'assets/core/js/module/block-choice'

export default function (): void {
  document.querySelectorAll<HTMLElement>('[data-toggle="help"]').forEach((link) => {
    const classToToggle = link.dataset.toggleClass as string
    const help = link.nextElementSibling as HTMLElement

    link.addEventListener('click', (event) => {
      event.preventDefault()
      help.classList.toggle(classToToggle)
    })
  })

  BlockChoice()
}
